export default "__VITE_ASSET__a98c5800__"